import React, { useContext } from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import NoticeDateInput from "../../components/inputs/NoticeDateInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeYesNoInput from '../../components/inputs/NoticeYesNoInput';
import { Collapse } from "@material-ui/core";
import NoticeIntegerInput from "../../components/inputs/NoticeIntegerInput";
import ContractUpdates from "./ContractUpdates";

function ContractProgress(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const { getDict } = useContext(FormTranslationContext)

    return (
        <>
            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("contractCompleted")}
                required />

            <NoticeDateInput
                formikProps={formikProps}
                id={gId("contractCompletedDate")}
                required />
            <Collapse in={gVal("contractCompleted")}>
                <NoticeYesNoInput
                    formikProps={formikProps}
                    id={gId("contractCompletedOnTime")}
                    required />
            </Collapse>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("totalContractValuePaid")}
                required />
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("currencyCode")}
                items={getDict("SL.MO.043")}
                required />
            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("contractFulfilledProperly")}
                required />
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("contractMonitored")}
                items={getDict("SL.MO.021")}
                required />
            <NoticeIntegerInput
                formikProps={formikProps}
                id={gId("updateCount")}
                required />

            <ContractUpdates
                formikProps={formikProps}
                id={id}
            />
        </>
    )
}

ContractProgress.propTypes = {};
export default ContractProgress;      